import type {
  AuthStatePayload,
  InjectPromptPayload,
  NavigateResultPayload,
  NavigateToNodePayload,
  PromptInjectResultPayload,
  RefreshConversationResultPayload,
} from '@claudafinil/shared/contract';
import type { ShellMessenger } from './shell-messenger';

export interface ShellCommands {
  navigateToNode(nodeId: string): Promise<NavigateResultPayload>;
  navigateToAnnotation(target: NavigateToNodePayload): Promise<NavigateResultPayload>;
  injectPrompt(
    text: string,
    variables?: InjectPromptPayload['variables'],
  ): Promise<PromptInjectResultPayload>;
  signIn(): Promise<AuthStatePayload>;
  signOut(): Promise<AuthStatePayload>;
  requestAuthToken(): Promise<string | null>;
  refreshConversation(): Promise<RefreshConversationResultPayload>;
}

export function createShellCommands(messenger: ShellMessenger): ShellCommands {
  return {
    navigateToNode(nodeId) {
      return messenger.sendRequest<NavigateResultPayload, 'NAVIGATE_TO_NODE'>(
        'NAVIGATE_TO_NODE',
        { nodeId },
      );
    },
    navigateToAnnotation(target) {
      return messenger.sendRequest<NavigateResultPayload, 'NAVIGATE_TO_NODE'>(
        'NAVIGATE_TO_NODE',
        target,
      );
    },
    injectPrompt(text, variables) {
      return messenger.sendRequest<PromptInjectResultPayload, 'INJECT_PROMPT'>(
        'INJECT_PROMPT',
        { text, ...(variables ? { variables } : {}) },
      );
    },
    signIn() {
      return messenger.sendRequest<AuthStatePayload, 'AUTH_SIGN_IN'>(
        'AUTH_SIGN_IN',
        {},
      );
    },
    signOut() {
      return messenger.sendRequest<AuthStatePayload, 'AUTH_SIGN_OUT'>(
        'AUTH_SIGN_OUT',
        {},
      );
    },
    async requestAuthToken() {
      const response = await messenger.sendRequest<
        { accessToken: string },
        'AUTH_TOKEN_REQUEST'
      >('AUTH_TOKEN_REQUEST', {});

      if (!response.accessToken) {
        return null;
      }

      return response.accessToken;
    },
    refreshConversation() {
      return messenger.sendRequest<
        RefreshConversationResultPayload,
        'REFRESH_CONVERSATION'
      >('REFRESH_CONVERSATION', {});
    },
  };
}
